<template>
 <router-view/>
 <div class="whatsapp-button">
   <div class="whatsapp-text">GelişimP Türkiye İletişim</div>
   <a href="https://wa.me/908508404863" target="_blank" class="whatsapp-link">
     <i class="fab fa-whatsapp"></i>
   </a>
 </div>
</template>

<script>

export default {
  name: 'App',
}
</script>

<style>
.whatsapp-button {
  position: fixed;
  bottom: 30px;
  right: 30px;
  z-index: 9999;
  display: flex;
  align-items: center;
  gap: 10px;
}

.whatsapp-text {
  background: #fff;
  padding: 10px 15px;
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 9px;
  font-size: 13px;
  color: #333;
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
  font-weight: 400;
  white-space: nowrap;
}

.whatsapp-link {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 60px;
  background-color: #25D366;
  border-radius: 50%;
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
  transition: all 0.3s ease;
}

.whatsapp-link:hover {
  transform: scale(1.1);
  box-shadow: 0 6px 16px rgba(0,0,0,0.2);
}

.whatsapp-link i {
  font-size: 32px;
  color: #fff;
}

@media (max-width: 768px) {
  .whatsapp-button {
    bottom: 20px;
    right: 20px;
  }
  
  .whatsapp-text {
    display: none;
  }
  
  .whatsapp-link {
    width: 50px;
    height: 50px;
  }
  
  .whatsapp-link i {
    font-size: 28px;
  }
}
</style>


